module.exports = __webpack_public_path__ + "img/DIHS_Logo_pos_rgb_600px_oc.7f0d69b2.png";